import { render, staticRenderFns } from "./DashboardTable.vue?vue&type=template&id=b7aca102"
import script from "./DashboardTable.vue?vue&type=script&lang=js"
export * from "./DashboardTable.vue?vue&type=script&lang=js"
import style0 from "./DashboardTable.vue?vue&type=style&index=0&id=b7aca102&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports